import React from 'react';
import HomeAdminTemplate from '../../../templates/Home/Admin/HomeAdminTemplate';

export default function HomeAdmin({ name }) {
  return <HomeAdminTemplate name={name} />;
}
